import React, { useMemo } from 'react'
import { SStyled } from 'styles/theme'
import SFlex from 'components/opinionless/SFlex'
import SLink from 'components/opinionless/SLink'
import SIcon from 'components/opinionless/SIcon'

import { Flex, Image } from 'rebass'
import ConditionalRender from 'utils/conditionalRender'
import { useOnboardingLogosQuery } from 'types/graphql'

interface Props {}

const Logos: React.FC<Props> = (props: Props) => {
    const PressRow = SStyled(SFlex)`
    margin: 20px 0 20px;
    width: 100%;
    align-items: center;
    justify-content: space-evenly;
`

    const PressLink = SStyled(SLink)`
    margin-right: ${(p) => p.theme.space[5]}px;
`

    const PressImage = SStyled(SIcon)`
    object-fit: contain;
`
    const { data } = useOnboardingLogosQuery({
        variables: {
            id: window.PROGRAM.id,
        },
    })

    const sortedLogos = useMemo(() => {
        if (data) {
            const logos = JSON.parse(JSON.stringify(data.onboardingLogos))
            return logos?.sort((a, b) => a.position - b.position)
        }

        return []
    }, [data])

    return (
        <>
            <ConditionalRender if={sortedLogos.length > 0}>
                <PressRow>
                    {sortedLogos.map((item, key) => {
                        if (key < 4) {
                            return (
                                <PressLink target="__blank" href={item.url} key={key}>
                                    <Flex>
                                        <Image src={`${item.image}`} />
                                    </Flex>
                                </PressLink>
                            )
                        }
                    })}
                </PressRow>
                <ConditionalRender if={sortedLogos.length > 3}>
                    <PressRow>
                        {sortedLogos.map((item, key) => {
                            if (key >= 4) {
                                return (
                                    <PressLink target="__blank" href={item.url} key={key}>
                                        <Flex>
                                            <Image src={`${item.image}`} />
                                        </Flex>
                                    </PressLink>
                                )
                            }
                        })}
                    </PressRow>
                </ConditionalRender>
            </ConditionalRender>
        </>
    )
}

export default Logos
